var map = {
	"./ABW.png": "ba53",
	"./AFG.png": "abe8",
	"./AGO.png": "6fac",
	"./AIA.png": "6e83",
	"./ALA.png": "d295",
	"./ALB.png": "0e0a",
	"./AND.png": "09f2",
	"./ANT.png": "c360",
	"./ARE.png": "030a",
	"./ARG.png": "2f1d",
	"./ARM.png": "fd1b",
	"./ASM.png": "fe7c",
	"./ATA.png": "9a90",
	"./ATG.png": "c872",
	"./AUS.png": "6ac8",
	"./AUT.png": "ffca",
	"./AZE.png": "4f81",
	"./BDI.png": "8c42",
	"./BEL.png": "d76d",
	"./BEN.png": "7e0d",
	"./BFA.png": "e33b",
	"./BGD.png": "1a80",
	"./BGR.png": "2c05",
	"./BHR.png": "04e0",
	"./BHS.png": "db11",
	"./BIH.png": "992e",
	"./BLM.png": "a993",
	"./BLR.png": "99d5",
	"./BLZ.png": "3739",
	"./BMU.png": "fcc4",
	"./BOL.png": "fe2e",
	"./BRA.png": "18cf",
	"./BRB.png": "2b64",
	"./BRN.png": "bc8f",
	"./BTN.png": "f582",
	"./BV.png": "a027",
	"./BVT.png": "2759",
	"./BWA.png": "4f4d",
	"./CAF.png": "88f4",
	"./CAN.png": "eb68",
	"./CCK.png": "1302",
	"./CHE.png": "9df5",
	"./CHL.png": "6b37",
	"./CHN.png": "f147",
	"./CIV.png": "1ff2",
	"./CMR.png": "5e75",
	"./COD.png": "7d27",
	"./COG.png": "79bf",
	"./COK.png": "04f1",
	"./COL.png": "2a0c",
	"./COM.png": "db48",
	"./CPV.png": "327c",
	"./CRI.png": "b2a8",
	"./CUB.png": "e0d6",
	"./CXR.png": "cadc",
	"./CYM.png": "243c",
	"./CYP.png": "d9e7",
	"./CZE.png": "8195",
	"./DEU.png": "3e35",
	"./DJI.png": "237d",
	"./DMA.png": "5155",
	"./DNK.png": "626e0",
	"./DOM.png": "8977",
	"./DZA.png": "7c674",
	"./ECU.png": "b5f1",
	"./EGY.png": "ea6e",
	"./EN.png": "904e",
	"./ERI.png": "c0f6",
	"./ESH.png": "648a",
	"./ESP.png": "4188",
	"./EST.png": "787e",
	"./ETH.png": "19aa4",
	"./EU.png": "bb75",
	"./FIN.png": "c7a3",
	"./FJI.png": "e199",
	"./FLK.png": "4b33",
	"./FR.png": "7b74",
	"./FRA.png": "edc5",
	"./FRO.png": "a079",
	"./FSM.png": "1326",
	"./GAB.png": "d9e6",
	"./GBR.png": "f986",
	"./GEO.png": "785c",
	"./GF.png": "0d2f",
	"./GGY.png": "f454",
	"./GHA.png": "4e60",
	"./GIB.png": "4140",
	"./GIN.png": "4ae6",
	"./GLP.png": "8386",
	"./GMB.png": "1f37",
	"./GNB.png": "b301",
	"./GNQ.png": "11f9",
	"./GRC.png": "db41",
	"./GRD.png": "7a31",
	"./GRL.png": "c1e8",
	"./GTM.png": "cb4f",
	"./GUF.png": "32f2",
	"./GUM.png": "d42f",
	"./GUY.png": "0251b",
	"./HKG.png": "ed61",
	"./HM.png": "04f5",
	"./HMD.png": "82cf",
	"./HND.png": "9e4c",
	"./HRV.png": "797d",
	"./HTI.png": "180e",
	"./HUN.png": "beec",
	"./IDN.png": "94a3",
	"./IMN.png": "f493",
	"./IND.png": "f7b9",
	"./IRL.png": "5493b",
	"./IRN.png": "23d4",
	"./IRQ.png": "3c12",
	"./ISL.png": "283b",
	"./ISR.png": "ff37",
	"./ITA.png": "4201",
	"./JAM.png": "47b3",
	"./JEY.png": "47b6",
	"./JOR.png": "f65c9",
	"./JPN.png": "5dd7",
	"./KAZ.png": "97a2",
	"./KEN.png": "5453",
	"./KGZ.png": "0aa9",
	"./KHM.png": "d8c77",
	"./KIR.png": "4841",
	"./KNA.png": "44f8",
	"./KOR.png": "b7bb",
	"./KV.png": "49a4",
	"./KWT.png": "8c79",
	"./LAO.png": "e60e",
	"./LBN.png": "c41c",
	"./LBR.png": "dc89",
	"./LBY.png": "3949",
	"./LCA.png": "87c3",
	"./LIE.png": "fdb5",
	"./LKA.png": "4803",
	"./LSO.png": "fbb2",
	"./LTU.png": "35aa",
	"./LUX.png": "8c4d",
	"./LVA.png": "526b",
	"./MAC.png": "b268",
	"./MAR.png": "0fa5",
	"./MCO.png": "fe37",
	"./MDA.png": "57f7",
	"./MDG.png": "9076",
	"./MDV.png": "9948",
	"./MEX.png": "23c7",
	"./MHL.png": "8632",
	"./MKD.png": "fd6e",
	"./MLI.png": "d3a2",
	"./MLT.png": "5c9a",
	"./MMR.png": "644c",
	"./MNE.png": "3224",
	"./MNG.png": "5aba",
	"./MNP.png": "917b",
	"./MOZ.png": "d61c",
	"./MQ.png": "bd4e",
	"./MRT.png": "d0a6",
	"./MSR.png": "0a14",
	"./MTQ.png": "ce46",
	"./MUS.png": "6cd1",
	"./MWI.png": "e178",
	"./MYS.png": "a3cd",
	"./MYT.png": "2051",
	"./NAM.png": "2093",
	"./NCL.png": "3948",
	"./NER.png": "5713",
	"./NFK.png": "600f",
	"./NGA.png": "cfd4",
	"./NIC.png": "63d5",
	"./NIU.png": "de93",
	"./NLD.png": "82c4",
	"./NOR.png": "6f51",
	"./NPL.png": "8968",
	"./NRU.png": "0683",
	"./NZL.png": "0fd2",
	"./OMN.png": "d4ec5",
	"./PAK.png": "a035",
	"./PAN.png": "1578",
	"./PCN.png": "63ba",
	"./PER.png": "2023",
	"./PF.png": "ea03",
	"./PHL.png": "73ec",
	"./PLW.png": "1955",
	"./PM.png": "c978",
	"./PNG.png": "b8e5",
	"./POL.png": "8dd0",
	"./PRI.png": "2d2d",
	"./PRK.png": "c383",
	"./PRT.png": "238d",
	"./PRY.png": "e1fd",
	"./PSE.png": "94852",
	"./PYF.png": "17c0",
	"./QAT.png": "fedb",
	"./RE.png": "3d84",
	"./REU.png": "0789",
	"./ROU.png": "3a8a",
	"./RUS.png": "208e",
	"./RWA.png": "13e6",
	"./SAU.png": "64a6",
	"./SDN.png": "c038",
	"./SEN.png": "7fa1",
	"./SGP.png": "830d",
	"./SGS.png": "ba4c",
	"./SHN.png": "1e4c",
	"./SLB.png": "8a14",
	"./SLE.png": "c4f0",
	"./SLV.png": "81c0",
	"./SMR.png": "884e",
	"./SOM.png": "1179",
	"./SPM.png": "8ee0",
	"./SRB.png": "e477",
	"./SSD.png": "5ca6",
	"./STP.png": "6a3c",
	"./SUR.png": "45c2",
	"./SVK.png": "9e85",
	"./SVN.png": "068e",
	"./SWE.png": "eec2",
	"./SWZ.png": "d094",
	"./SYC.png": "d348",
	"./SYR.png": "2112",
	"./TCA.png": "3832",
	"./TCD.png": "c24a",
	"./TGO.png": "2777",
	"./THA.png": "4c9e",
	"./TJK.png": "ea5f",
	"./TKM.png": "e714",
	"./TLS.png": "fdd1",
	"./TON.png": "74e6",
	"./TP.png": "72bc",
	"./TTO.png": "9c54",
	"./TUN.png": "f907",
	"./TUR.png": "8133",
	"./TUV.png": "be67",
	"./TWN.png": "5435",
	"./TZA.png": "86fb",
	"./UGA.png": "3194",
	"./UKR.png": "0684",
	"./UM.png": "97e5",
	"./UMI.png": "a206",
	"./URY.png": "ad4d6",
	"./USA.png": "7b68",
	"./UZB.png": "733d",
	"./VAT.png": "5806",
	"./VCT.png": "0141",
	"./VEN.png": "e0c9",
	"./VGB.png": "f339",
	"./VIR.png": "72fd",
	"./VNM.png": "b63f",
	"./VUT.png": "bb37",
	"./WLF.png": "01b4",
	"./WSM.png": "d6d5",
	"./XXK.png": "542f",
	"./XZ.png": "d381",
	"./YEM.png": "92e3",
	"./ZAF.png": "5d3c",
	"./ZMB.png": "566b",
	"./ZWE.png": "5273",
	"./_abkhazia.png": "e188",
	"./_british-antarctic-territory.png": "2ed6",
	"./_commonwealth.png": "257ec",
	"./_england.png": "bf34",
	"./_gosquared.png": "d12a",
	"./_mars.png": "3bd1",
	"./_nagorno-karabakh.png": "fe73",
	"./_nato.png": "5025",
	"./_northern-cyprus.png": "c4c2",
	"./_olympics.png": "f02e",
	"./_red-cross.png": "e244",
	"./_scotland.png": "82cb",
	"./_somaliland.png": "9490",
	"./_south-ossetia.png": "8cef",
	"./_united-nations.png": "8352",
	"./_wales.png": "1da2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1620";